import React from "react";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@material-ui/core";

const ModalDialog = (props) => {

  const callButtonSave = () => {
    props.saveMethod();
  };

  return (
    <div>
      <Dialog
        fullWidth={props.fullWidth}
        maxWidth={props.maxWidth}
        open={props.open}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{props.title} </DialogTitle>
        <DialogContent>
          <DialogContentText>{props.subTitle}</DialogContentText>
          {props.children}
        </DialogContent>
        {
          props.hiddenAction ?
            null
            :
            <DialogActions>
              <Button onClick={props.close} color="primary" variant="contained">
                Cancelar
              </Button>
              <Button onClick={callButtonSave} color="secondary" variant="contained">
                {props.textSave ? props.textSave: "Salvar"}
              </Button>
              {props.action}
            </DialogActions>
        }
        {
          props.closeButton ?
            <DialogActions>
              <Button onClick={props.close} variant="outlined" color="primary">
                Fechar
              </Button>
              {props.action}
            </DialogActions>
            : null
        }
      </Dialog>

      {props.button}
    </div>
  )
}

export default ModalDialog;
